<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddAutomaticCashRegisterReport') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="report.date"></datepicker>

                <vs-divider>
                    <h5>{{$t('Payment') |ToUppercase}}</h5>
                </vs-divider>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <h6>{{$t('Coins') |ToUppercase}}</h6>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.10€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report010.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report010.amount*report.report010.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.20€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report020.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report020.amount*report.report020.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.50€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report050.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report050.amount*report.report050.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>1€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report1.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report1.amount*report.report1.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>2€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report2.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report2.amount*report.report2.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <h5>{{$t('CoinsTotal')}}: {{(
                            (report.report010.amount * report.report010.value) +
                            (report.report020.amount * report.report020.value) +
                            (report.report050.amount * report.report050.value) +
                            (report.report1.amount * report.report1.value) +
                            (report.report2.amount * report.report2.value)).toFixed(2)}}€</h5>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <h6>{{$t('Banknotes') |ToUppercase}}</h6>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>5€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report5.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report5.amount*report.report5.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>10€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report10.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report10.amount*report.report10.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>20€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report20.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report20.amount*report.report20.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>50€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.report50.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.report50.amount*report.report50.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <h5>{{$t('BanknotesTotal')}}: {{(
                            (report.report5.amount * report.report5.value) +
                            (report.report10.amount * report.report10.value) +
                            (report.report20.amount * report.report20.value) +
                            (report.report50.amount * report.report50.value)).toFixed(2)}}€</h5>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-center">
                        <h5>{{$t('CoinsBanknotesTotal')}}: {{(
                            (report.report010.amount * report.report010.value) +
                            (report.report020.amount * report.report020.value) +
                            (report.report050.amount * report.report050.value) +
                            (report.report1.amount * report.report1.value) +
                            (report.report2.amount * report.report2.value) +
                            (report.report5.amount * report.report5.value) +
                            (report.report10.amount * report.report10.value) +
                            (report.report20.amount * report.report20.value) +
                            (report.report50.amount * report.report50.value)).toFixed(2)}}€</h5>
                    </div>
                </div>


                <vs-divider class="mt-8">
                    <h5>{{$t('Filling') |ToUppercase}}</h5>
                </vs-divider>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <h6>{{$t('Coins') |ToUppercase}}</h6>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.10€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp010.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp010.amount*report.reportp010.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.20€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp020.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp020.amount*report.reportp020.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>0.50€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp050.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp050.amount*report.reportp050.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>1€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp1.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp1.amount*report.reportp1.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <h5>{{$t('CoinsTotal')}}: {{(
                            (report.reportp010.amount * report.reportp010.value) +
                            (report.reportp020.amount * report.reportp020.value) +
                            (report.reportp050.amount * report.reportp050.value) +
                            (report.reportp1.amount * report.reportp1.value)).toFixed(2)}}€</h5>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <h6>{{$t('Banknotes') |ToUppercase}}</h6>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>5€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp5.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp5.amount*report.reportp5.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <small>10€</small><br>
                                <vs-input class="w-full" type="number" name="amount" v-model="report.reportp10.amount"/>
                            </div>
                            <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                                <p class="mt-8 mb-4">{{ (report.reportp10.amount*report.reportp10.value).toFixed(2) + "€"}}</p>
                            </div>
                        </div>
                        <h5>{{$t('BanknotesTotal')}}: {{(
                            (report.reportp5.amount * report.reportp5.value) +
                            (report.reportp10.amount * report.reportp10.value)).toFixed(2)}}€</h5>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-center">
                        <h5>{{$t('CoinsBanknotesTotal')}}: {{(
                            (report.reportp010.amount * report.reportp010.value) +
                            (report.reportp020.amount * report.reportp020.value) +
                            (report.reportp050.amount * report.reportp050.value) +
                            (report.reportp1.amount * report.reportp1.value) +
                            (report.reportp5.amount * report.reportp5.value) +
                            (report.reportp10.amount * report.reportp10.value)).toFixed(2)}}€</h5>
                    </div>
                </div>

                <vs-divider/>
                <h5>{{$t('TransferTRR')}}: {{(
                    (report.report010.amount * report.report010.value) +
                    (report.report020.amount * report.report020.value) +
                    (report.report050.amount * report.report050.value) +
                    (report.report1.amount * report.report1.value) +
                    (report.report2.amount * report.report2.value) +
                    (report.report5.amount * report.report5.value) +
                    (report.report10.amount * report.report10.value) +
                    (report.report20.amount * report.report20.value) +
                    (report.report50.amount * report.report50.value) -
                    (report.reportp010.amount * report.reportp010.value) -
                    (report.reportp020.amount * report.reportp020.value) -
                    (report.reportp050.amount * report.reportp050.value) -
                    (report.reportp1.amount * report.reportp1.value) -
                    (report.reportp5.amount * report.reportp5.value) -
                    (report.reportp10.amount * report.reportp10.value)).toFixed(2)}}€</h5>
                <vs-divider/>

                <small>{{$t('Notes') |ToUppercase}}</small><br>
                <vs-textarea v-model="report.notes"></vs-textarea>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="addAutomaticCashRegisterReport">{{ $t("Add") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                report: {
                    date: new Date(),
                    report010: {value: 0.10, amount: 0},
                    report020: {value: 0.20, amount: 0},
                    report050: {value: 0.50, amount: 0},
                    report1: {value: 1, amount: 0},
                    report2: {value: 2, amount: 0},
                    report5: {value: 5, amount: 0},
                    report10: {value: 10, amount: 0},
                    report20: {value: 20, amount: 0},
                    report50: {value: 50, amount: 0},
                    reportp010: {value: 0.10, amount: 0},
                    reportp020: {value: 0.20, amount: 0},
                    reportp050: {value: 0.50, amount: 0},
                    reportp1: {value: 1, amount: 0},
                    reportp5: {value: 5, amount: 0},
                    reportp10: {value: 10, amount: 0},
                    notes: ""
                },
            };
        },
        methods: {
            addAutomaticCashRegisterReport() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.post("/report/add?type=automaticCashRegisterReport", {
                    date: thisIns.report.date,
                    value010: thisIns.report.report010.value,
                    value020: thisIns.report.report020.value,
                    value050: thisIns.report.report050.value,
                    value1: thisIns.report.report1.value,
                    value2: thisIns.report.report2.value,
                    value5: thisIns.report.report5.value,
                    value10: thisIns.report.report10.value,
                    value20: thisIns.report.report20.value,
                    value50: thisIns.report.report50.value,
                    valueP010: thisIns.report.reportp010.value,
                    valueP020: thisIns.report.reportp020.value,
                    valueP050: thisIns.report.reportp050.value,
                    valueP1: thisIns.report.reportp1.value,
                    valueP5: thisIns.report.reportp5.value,
                    valueP10: thisIns.report.reportp10.value,
                    amount010: parseInt(thisIns.report.report010.amount),
                    amount020: parseInt(thisIns.report.report020.amount),
                    amount050: parseInt(thisIns.report.report050.amount),
                    amount1: parseInt(thisIns.report.report1.amount),
                    amount2: parseInt(thisIns.report.report2.amount),
                    amount5: parseInt(thisIns.report.report5.amount),
                    amount10: parseInt(thisIns.report.report10.amount),
                    amount20: parseInt(thisIns.report.report20.amount),
                    amount50: parseInt(thisIns.report.report50.amount),
                    amountP010: parseInt(thisIns.report.reportp010.amount),
                    amountP020: parseInt(thisIns.report.reportp020.amount),
                    amountP050: parseInt(thisIns.report.reportp050.amount),
                    amountP1: parseInt(thisIns.report.reportp1.amount),
                    amountP5: parseInt(thisIns.report.reportp5.amount),
                    amountP10: parseInt(thisIns.report.reportp10.amount),
                    notes: thisIns.report.notes,
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Poročilo avotmatske blagajne shranjeno",
                        color: "success",
                    });
                    thisIns.$router.push('/report/automaticCashRegister');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
        },
    };
</script>